import React from 'react';
import { Box, Typography } from '@mui/material';
import { CloudPosData } from 'common/types/integrations';
import CopyableText from 'components/CopyableText';
import MerchantSecret from './MerchantSecret';
import { useTranslation } from 'services/localization';

export interface Props {
	merchantId: string;
	storeDetails: { name: string; id: string }[];
	cloudPosData: CloudPosData | undefined;
}

const CloudPosDetails = (props: Props) => {
	const { t } = useTranslation();
	return (
		<>
			<Typography variant="body1" sx={{ mb: 3, fontWeight: 500 }}>
				{t('integrations.cloudPos.accountDetails', 'Account details')}
			</Typography>
			<Box mb={3}>
				<Typography variant="body2" gutterBottom>
					{t('integrations.cloudPos.merchantId', 'Merchant ID')}
				</Typography>
				<CopyableText text={props.merchantId} />
			</Box>
			<Box mb={3}>
				<Typography variant="body2" gutterBottom>
					{t('integrations.cloudPos.merchantSecret', 'Merchant Secret')}
				</Typography>
				<MerchantSecret
					merchantId={props.merchantId}
					secret={props.cloudPosData?.merchantSecret ?? undefined}
					secretCreated={props.cloudPosData?.secretCreated}
				/>
			</Box>
			<Box mt={1}>
				<Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
					{t('integrations.cloudPos.storeIds', 'Store IDs')}
				</Typography>
				{props.storeDetails.map((store) => (
					<Box mt={2}>
						<Typography variant="body2" gutterBottom>
							{store.name}
						</Typography>
						<CopyableText text={store.id} />
					</Box>
				))}
			</Box>
		</>
	);
};

export default CloudPosDetails;
